var msg = new Array();
msg['ERR_PRIVACY']='Du måste godkänna integritetspolicyn.';
msg['ERR_MISSINGFIELDS']='Fyll i alla obligatoriska fält.';
msg['ERR_FILLEMAILFIELD']='Fyll i e-postfältet.';
msg['ERR_USEREXISTS']='Användaren finns redan.';
msg['ERR_INVALIDMAIL']='Ogiltig e-postadress.';
msg['ERR_CLIENTMANDATORYFIELDS']='Fyll i alla obligatoriska fält';
msg['ERR_NOSIZESELECTED']='Du måste välja en storlek';
msg['ERR_LOGINREQUIRED']='Inloggning krävs';
msg['ERR_LOGININVALID']='Ogiltig e-post eller lösenord';
msg['ERR_CARRIERMISSING']='Du måste välja en leverans typ först.';
msg['ERR_CARRIER_COST_MISSING']='Ingen avgift tillgänglig för valt lands fraktföretag och beställningsvikt.';
msg['MSG_DEFERRED_DISPATCH_COMPUTATION']='Endast orderbokningsläge kommer att aktiveras och fraktavgifter kommer att skickas till dig via e-post.';
msg['MSG_ADDEDTOWISHLIST']='Produkt tillagd på din önskelista';
msg['MSG_NEWSLETTER_COMPLETED']='Lyckad registrering';
msg['MSG_ADDEDTOCART']='Produkterna har lagts till i din kundvagn';
msg['MSG_REMOVEDFROMCART']='Produkten har tagits bort från varukorgen';
msg['MSG_DELETEALLPRODUCTS']='Är du säker på att du vill ta bort alla produkter från varukorgen?';
msg['DELETEALLPRODUCTSERROR']='Fel vid borttagning av produkter från varukorgen';
msg['MSG_WAIT']='Vänta snälla...';
msg['MSG_SUBJECT_PRODUCTSHARE']=' delade något med dig';
msg['MSG_SENDER_PRODUCTSHARE']='Ditt namn';
msg['MSG_MESSAGE_PRODUCTSHARE']='Meddelande';
msg['MSG_MAILSENT']='E-postmeddelanden skickade';
msg['MSG_MIXED_INTANGIBLE']='Denna produkt kan inte köpas tillsammans med produkter du redan har i din varukorg.';
msg['MSG_MIXED_CART']='Denna produkt kan inte köpas tillsammans med produkter du redan har i din varukorg eftersom de finns i olika lager.';
msg['MSG_INSUFFICIENT_STOCK']='Tyvärr har vi för tillfället inte tillräckligt med produkt tillgänglighet.';
msg['MSG_APPLIEDVATCHANGED']='Efter att faktureringsdata har uppgraderats har moms som tillämpas på din beställning ändrats. Kontrollera det nya beloppet när sidan uppdateras.';
msg['MSG_GENERIC_ERROR']='Tyvärr, ett fel inträffade.';
msg['MSG_COUPON_ERROR']='Den angivna kupongkoden är inte giltig eller har redan använts.';
msg['MSG_COUPON_VALID']='Den angivna kupongkoden har accepterats framgångsrikt.';
msg['MSG_RECOVEREMAILSENT']='Kontrollera din e-post och ange koden för att bekräfta lösenordsändringen.';
msg['MSG_RECOVEREMAILSENT_ERROR']='Varning: Du är inte registrerad med denna e-postadress eller så återställer du redan ditt lösenord.';
msg['MSG_SUBSCRIPTION_FAILURE']='Se till att du inte har någon annan aktiv prenumeration.';
msg['MSG_EXTRAUELIMIT']='Du kan inte checka ut beställningar med en skatt mindre än 2000.00 &euro;';
msg['MSG_RULE_REJECT']='Produkten kan inte läggas till i varukorgen på grund av regel :rule';
msg['LABEL_ARTICLES']='artiklar';
msg['LABEL_WARNING']='Varning';
msg['LABEL_NOTAPPLICABLE']='Inte tillämpligt';
msg['LABEL_ALREADYREGISTEREDUSERES']='Redan registrerade användare';
msg['LABEL_SENTINVITES']='Skickade inbjudningar';
msg['LABEL_NOTSENTINVITES']='Osända inbjudningar';
msg['LABEL_INVITES_ALREADY_SENT']='Användare redan inbjudna';
msg['LABEL_SUBMIT']='Skicka in';
msg['LABEL_SELECTALL']='Välj alla';
msg['MSG_MESSAGE_SENT']='Meddelandet skickades framgångsrikt!';
msg['MSG_RETURN_REQUEST_SUCCESS'] = 'Returnbegäran skapad framgångsrikt';
msg['MSG_SAVE_SUCCESS'] = 'Sparande lyckades';
msg['MSG_SUBSCRIBED'] = 'Registreringen lyckades';
msg['MSG_PROFILECONSENT_SAVED'] = 'Dina kontaktpreferenser har uppdaterats';
msg['wrongpassword'] = 'Fel lösenord';
msg['passwordnotcomplex'] = 'Lösenordet är inte tillräckligt komplext';
msg['MSG_PASSWORD_OK'] = 'Lösenordet har ändrats korrekt';
msg['MSG_PASSWORD_NOT_EQUAL'] = 'lösenorden matchar inte';
msg['MSG_PRIVACY_POLICY'] = 'Du måste acceptera integritetspolicyn';
msg['MSG_SUBSCRIPTION_NO_RENEWABLE'] = 'För många dagar har gått så att prenumerationen inte längre kan förnyas';
msg['MSG_GIFTCARD_SUCCESS'] = 'Ditt presentkort har accepterats';
msg['INVALID_GIFTCARD'] = 'Ogiltigt presentkort';
msg['ERR_REWIXSYNC_URL']= 'Ogiltig URL';
msg['msg.form.invalidtype'] = 'Ett fel har inträffat. Kontakta administrationen och rapportera följande: "Ogiltig eller saknad kontakttyp."';
msg['login.user.unexisting'] = "Användaren finns inte";
msg['msg.form.invalidemail'] = 'Ogiltig eller saknad e-post';
msg['msg.form.invalidrecipients'] = 'Ett fel har inträffat. Kontakta administrationen och rapportera följande: "Ogiltig eller avsaknad av kontaktmottagare."';

var portal_livestock_available='TILLGÄNGLIG';
var portal_livestock_soldout='SLUT PÅ LAGER';

var activity_online_shop = 'onlinebutik';
var activity_shop = 'butik';
var activity_private_sales = 'privata försäljningar';
var activity_outlet = 'försäljningsställe';
var activity_online_outlet = 'online-försäljningsställe';
var activity_store_chain = 'butikskedja';
var activity_purchasing_group = 'inköpsgrupp';
var activity_broker = 'mäklare/agent';
var activity_ebay_amazon = 'ebay/amazon-butik';
var activity_other = 'annat';

var general='Allmän';
var general_personaldata='Personuppgifter';
var general_olduser='Registrerad användare';
var general_newuser='Ny användare';
var general_username="Användarnamn";
var general_password="Lösenord";
var general_contacts='Kontakter';
var general_phone='Telefonnr';
var general_skype='Skype';
var general_website='Webbplats';
var general_fax='Fax';
var general_firstname='Förnamn';
var general_lastname='Efternamn';
var general_company='Företag';
var general_birth='Födelsedatum';
var general_code='Kod';
var general_model='Modell';
var general_quantity='Kvantitet';
var general_availability='Tillgänglighet';
var general_price='Pris';
var general_warning='Varning';
var general_dispatchto='Företagsnamn/Adressat';
var general_careof='C/O';
var general_vat='Moms';
var general_address='Adress';
var general_addresstype='Adresstyp';
var general_addressnumber='Nummer';
var general_city='Stad';
var general_prov='Prov';
var general_zip='Postnummer';
var general_mobile='Mobil';
var general_notes='Anteckningar';
var general_orders='Ordrar';
var general_fgfdiscounts='Vänner och rabatter';
var general_myprofile='Mitt profil';
var general_pieces='st';
var general_size_table='Storlekstabell';
var general_details='Detaljer';
var general_invoice='Faktura';
var general_creditnote='Kreditnota';
var general_cart= 'Kundvagn';
var general_country='Land';
var general_carrier='Bärare';
var general_dispatch_address='Skicka adress';
var general_invoice_address='Fakturaadress';
var general_receive_newsletter='Ta emot nyhetsbrev';
var general_copydispatchfrombilldata='Kopiera från faktureringsdata';
var general_instructions="Instruktioner";
var general_add="Lägg till";
var general_status="Status";
var general_toomanyfilters="Du har nått det maximala antalet tillåtna filter.";

var help_addresstype='Gata, Torg, Gata, ...';
var help_address='Gatunamn';
var help_dispatchmobile='Detta nummer kommer att användas av transportören.';
var help_ordercfpiva='Ett tomt värde lägger automatiskt till 20% moms på beställningsvärdet.';
var help_cf='Ange ditt personnummer';

var buttons_save='Spara';
var buttons_changepw='Ändra lösenord';
var buttons_close='Stäng';
var buttons_continue='Fortsätt';
var buttons_confirm='Bekräfta';
var buttons_cancel='Avbryt';
var buttons_invite='Bjud in';
var buttons_continueshopping='Fortsätt handla';
var buttons_gocheckout='Gå till kassan';

var messages_product_soldout='Produkt slut i lager.';
var messages_noselection='Inget val';
var messages_invaliddata='Ogiltiga data.';
var messages_recoverpassword='Återställ lösenord';
var messages_recoverpassword_info='Ange e-postadressen du prenumererar på<br/>Du kommer att få ett e-postmeddelande med instruktioner för att återställa ditt lösenord';
var messages_invitefriends='Bjud in dina vänner';
var messages_confirmpassword='Bekräfta lösenord';
var messages_sendingmail='Skickar e-post...';
var messages_mailsent='E-post skickad.';
var messages_password='Lösenord';
var messages_confirmpassword='Bekräfta lösenord';
var messages_requiredfield='Obligatoriskt fält';

var subscribe_personaldata='Personuppgifter';
var subscribe_privacyintro='Du måste acceptera följande villkor för att fortsätta prenumerationen.';
var subscribe_privacydisclaimer = 'Du måste acceptera integritetsfriskrivningen för att fortsätta prenumerationen.';
var subscribe_privacy1='Jag accepterar integritetsfriskrivningen';
var subscribe_privacy2='Jag accepterar att mina personuppgifter kan användas av andra företag för marknadsföringskampanjer (valfritt)';

var order_status='Status'
var order_date='Datum'
var order_dispatchdate='Skickat';

var returnedgoods_requests="Returnerad vara";
var returnedgoods_motivations="Motivering för returnering";
var returnedgoods_requestcode="Begäran om returnerad vara kod";
var returnedgoods_requestdate="Begärande datum";
var returnedgoods_motivations_1="Jag gillar inte produkten";
var returnedgoods_motivations_2="Produkten är för stor/liten";
var returnedgoods_motivations_3="Produkten är skadad";
var returnedgoods_motivations_4="Produkten överensstämmer inte med den beställda varan";
var returnedgoods_motivations_5="Produkten finns inte i paketet";
var returnedgoods_motivations_other = "Annat";

var i18nOrderStatus = new Array();
i18nOrderStatus[0]='Pågående';
i18nOrderStatus[1]='I betalning';
i18nOrderStatus[2]='Bekräftad';
i18nOrderStatus[3]='Skickad';
i18nOrderStatus[4]='Levererad';
i18nOrderStatus[5]='Bokad';
i18nOrderStatus[6]='Dropshipping';
i18nOrderStatus[2000]='Avbruten';
i18nOrderStatus[2001]='Fel';
i18nOrderStatus[3001]='I process';
i18nOrderStatus[3002]='Klar';

i18nOrderStatus[1000]='Betalning avbruten';
i18nOrderStatus[2002]='Betalningsverifiering misslyckades';
i18nOrderStatus[2003]='Återbetalad';
i18nOrderStatus[2005]='Avvisad';
i18nOrderStatus[3003]='Inte leveransbar';
i18nOrderStatus[5001]='Inte auktoriserad';
i18nOrderStatus[5002]='Auktoriserad';
i18nOrderStatus[5003]='Dropshipping - Ökande';